var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80677 2.12374C6.36006 1.61656 7.08337 1.33521 7.83394 1.33521H16.3337C17.4382 1.33521 18.3337 2.23064 18.3337 3.33521V17.6685C18.3337 18.7731 17.4382 19.6685 16.3337 19.6685H3.66699C2.56242 19.6685 1.66699 18.7731 1.66699 17.6685V7.23824C1.66699 6.39732 2.01993 5.59501 2.63982 5.02678L5.80677 2.12374Z",
    fill: "#B9D6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 7.16862H7.49967V3.00195",
    stroke: "#B9D6DE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3054_8107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 17,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3466 2.87581C16.7371 2.48528 17.3703 2.48528 17.7608 2.87581L19.2929 4.40787C19.6834 4.7984 19.6834 5.43156 19.2929 5.82209L7.64475 17.4702C7.24717 17.8678 6.74587 18.1456 6.19801 18.2721L4.14162 18.7466C3.70958 18.8463 3.32237 18.4591 3.42207 18.0271L3.89662 15.9707C4.02305 15.4228 4.3009 14.9215 4.69847 14.5239L16.3466 2.87581Z",
    fill: "#FFAF00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3054_8107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3466 2.87581C16.7371 2.48528 17.3703 2.48528 17.7608 2.87581L19.2929 4.40787C19.6834 4.7984 19.6834 5.43156 19.2929 5.82209L7.64475 17.4702C7.24717 17.8678 6.74587 18.1456 6.19801 18.2721L4.14162 18.7466C3.70958 18.8463 3.32237 18.4591 3.42207 18.0271L3.89662 15.9707C4.02305 15.4228 4.3009 14.9215 4.69847 14.5239L16.3466 2.87581Z",
    fill: "#62A1B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0537,
    y: 2.1687,
    width: 4.16667,
    height: 4.16667,
    transform: "rotate(45 17.0537 2.1687)",
    fill: "#62A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67969 14.543L7.62597 17.4892L4.67969 20.4355L1.73341 17.4892L4.67969 14.543Z",
    fill: "#8CBBC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.50098,
    y: 15.7214,
    width: 4.16667,
    height: 2.5,
    transform: "rotate(45 3.50098 15.7214)",
    fill: "#62A1B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool2);
export default __webpack_public_path__ + "static/media/tool_2.de8bb6f4e3915becffda6ade4cfd7f18.svg";
export { ForwardRef as ReactComponent };